const items = {
	"article.lable": "文章",
	"article.fields.article.count.label": "文章数量",
};

export default items;
